import { render, staticRenderFns } from "./tabFileHistory.vue?vue&type=template&id=7b865659&scoped=true&"
import script from "./tabFileHistory.vue?vue&type=script&lang=js&"
export * from "./tabFileHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b865659",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b865659')) {
      api.createRecord('7b865659', component.options)
    } else {
      api.reload('7b865659', component.options)
    }
    module.hot.accept("./tabFileHistory.vue?vue&type=template&id=7b865659&scoped=true&", function () {
      api.rerender('7b865659', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabFileHistory.vue"
export default component.exports